function clamp01(n: number): number {
  if (!Number.isFinite(n)) return 0.5;
  return Math.max(0, Math.min(1, n));
}

/** CSS object-position for a vertical focal point (0=top, 1=bottom). */
export function focalObjectPosition(focalY: number | undefined): string {
  return `50% ${Math.round(clamp01(focalY ?? 0.5) * 100)}%`;
}

/** Map a drag delta (px, +down) to the next focal point given the overflow. */
export function dragToFocalY(
  current: number,
  dyPx: number,
  overflowPx: number
): number {
  if (overflowPx <= 0) return current;
  return clamp01(current - dyPx / overflowPx);
}
